/** Tasks — edit form (RHF + zod + shadcn Form via Refine useForm). */
import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  TASK_STATUS,
  updateTaskSchema,
  type Task,
  type UpdateTaskInput,
} from "@aos/shared";

import { Form } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { PageHeader, LoadingState, ErrorState } from "../projects/_shared";
import {
  FormGrid,
  SelectField,
  TextAreaField,
  TextField,
} from "../projects/_form";

export function TaskEdit() {
  const form = useForm<Task, any, UpdateTaskInput>({
    resolver: zodResolver(updateTaskSchema),
    refineCoreProps: { resource: "tasks", action: "edit" },
  });

  const {
    refineCore: { formLoading, query },
    saveButtonProps,
    control,
  } = form;

  if (query?.isLoading) return <LoadingState label="Loading task…" />;
  if (query?.isError) return <ErrorState error={query.error} />;

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <PageHeader title="Edit Task" description="Update task details." />
      <Form {...form}>
        <form onSubmit={saveButtonProps.onClick}>
          <Card>
            <CardHeader>
              <CardTitle className="text-base">Task details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <FormGrid>
                <TextField
                  control={control}
                  name="artifact_id"
                  label="Artifact ID"
                />
                <SelectField
                  control={control}
                  name="task_status"
                  label="Status"
                  options={TASK_STATUS}
                />
              </FormGrid>
              <TextField
                control={control}
                name="assignee_user_id"
                label="Assignee User ID"
              />
              <TextAreaField
                control={control}
                name="instruction"
                label="Instruction"
              />
              <TextAreaField control={control} name="result" label="Result" />
            </CardContent>
            <CardFooter className="justify-end">
              <Button type="submit" disabled={formLoading}>
                {formLoading ? "Saving…" : "Save Changes"}
              </Button>
            </CardFooter>
          </Card>
        </form>
      </Form>
    </div>
  );
}

export default TaskEdit;
